import { Component, OnInit, ViewChild } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TranslateService } from "@ngx-translate/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { CommonService } from "src/app/core/services/common.service";
import { PlacaService } from "../../services/placa.service";
import { Placa } from "../../models/placaMailBox";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { ListValueService } from "src/app/core/services/list-value.service";
import { AdvancedFiltersService } from "src/app/core/services/advancedFilters.service";
import {
  Options,
  OptionsOutTable,
} from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-mailbox",
  templateUrl: "./list-mailbox.component.html",
  styleUrls: ["./list-mailbox.component.scss"],
})
export class ListMailboxComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("outTable") filtersOutTable: FiltersComponent;
  placaList;
  filtersTable: string;
  showTableFilter: boolean = false;
  showFiltersOut: boolean = false;
  showFilterButtons: boolean = false;
  filtersTableJSON;
  filtersSearch = "";
  filterList = FilterConstants.placaMailBox;
  tableList = TableConstants.placaMailBox;
  routing = RoutingConstants.placaMailBox;
  public options: Options = TableConstants.NotShowCreateDeleteAndArrowUpDown;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  filterListOutTable = FilterConstants.placaOutTable;
  filtersSearchOutTable = "";
  public optionsFiltersOutTable: OptionsOutTable = {
    isOutTable: true,
    showFilters: false,
    style: { "min-width": "1278px" },
    showCheckbox: false,
  };
  constructor(
    private mailboxPlacaService: PlacaService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService,
    private listValueService: ListValueService,
    private advancedFiltersService: AdvancedFiltersService
  ) {
    this.options.style = { "min-width": "1278px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "peCreacion",
      ScreenConstants.placa.mailBoxPlaca
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
    this.filtersSearchOutTable =
      this.filtersTableStateService.composeFiltersOutTable(
        this.filterListOutTable
      );
  }

  ngOnInit(): void {
    this.getList();
    this.getAnalystList();
    this.getFiltersByUser();
    this.getBrandsList();
    this.getEstadosList();
    this.getTiposdeVehiculoList();
    this.getMotorList();
    this.getTipoPlacaList();
    this.getCertificateList();
    this.loadListMotivosReedicion();
  }

  getList() {
    let filters = this.commonService.concatThreeFilters(
      this.filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    if (!this.sweetAlertService.anyStepsQueue()) {
      this.sweetAlertService.sweetAlertLoading();
    } else {
      this.sweetAlertService.showSwalQueue();
    }
    this.mailboxPlacaService.getPlacaMailBoxList(filters).subscribe(
      (data) => {
        this.placaList = data.content.map((e) => {
          return Placa.placaFromJson(e);
        });
        this.numPages = data.totalPages == 0 ? 1 : data.totalPages;
        this.numElements = data.numberOfElements;
        this.totalElements = data.totalElements;
        if (!this.sweetAlertService.anyStepsQueue()) {
          this.sweetAlertService.sweetAlertClose();
        }
        this.sweetAlertService.resetStepsQueue();
        if (data.content && data.content.length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getAnalystList() {
    this.listValueService.listaAnalistasActivos().subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Analista");
        data.sort(function (a, b) {
          if (a.usuarioId.toUpperCase() < b.usuarioId.toUpperCase()) {
            return -1;
          }
          if (a.usuarioId.toUpperCase() > b.usuarioId.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        this.filterList[pos]["selectorConf"].dataList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getBrandsList() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Marca");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getEstadosList() {
    this.listValueService.listEstadosByScreen("ES_BUZON_PLACA").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Estado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  getTiposdeVehiculoList() {
    this.listValueService.listTipoVehiculo().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo homologado"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getMotorList() {
    this.listValueService.listMotor().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Motor");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getTipoPlacaList() {
    this.listValueService.listTipoPlaca().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo de placa"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  loadListMotivosReedicion() {
    this.listValueService.listMotivosReedicion().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Motivo reedición"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCertificateList() {
    this.listValueService.listCertificates("3", "true").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Tipo solicitud");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersOutTable.filtersSelectorSearch = [];
        this.filtersOutTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        this.filtersOutTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersSearchOutTable = this.filtersOutTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          if (!this.showFiltersOut) {
            this.showFilterButtons = false;
          }
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  toggleFilterButtons(item: boolean) {
    this.showFiltersOut = item;
    if (this.showFiltersOut) {
      this.showFilterButtons = true;
    } else if (!this.showTableFilter) {
      this.showFilterButtons = false;
    }
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.getList();
  }

  getFiltersByUser() {
    this.advancedFiltersService.getAdvancedFiltersByUser("PLACA").subscribe(
      (data) => {
        this.filterListOutTable = this.advancedFiltersService.renderFiltersOut(
          data,
          this.filterListOutTable
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
